<template>
  <div>
    <p class="cm-mg-p-wzd">2. {{ $t('production.defects_info') }}</p>
    <hr />
    <div class="px-3">
      <div class="form-group has-label">
        <label
          >{{ $t('production.defects_number') }}:
          <strong>{{ model.defect_quantity }}</strong></label
        >
      </div>
      <div
        v-for="(_, index) in model.defect_quantity"
        :key="index"
        class="px-3"
      >
        <div class="row">
          <div
            class="row py-3 mb-4 shadow-sm col-11"
            style="border: 0.5px solid #6ba6524d"
          >
            <div class="col-12 col-sm-4 col-lg-2">
              <fg-input
                type="number"
                min="1"
                max="10000"
                :label="`${$t('common_words.order')}: `"
                v-model="model.defect_order[index]"
                :name="`common_words.order_${index}`"
                v-validate="modelValidations.defect_order"
                :error="getFieldErrorByIndex('common_words.order', true, index)"
              ></fg-input>
            </div>
            <div class="col-12 col-sm-8 col-lg-5">
              <fg-input
                :label="`${$t('production.defect')} ${index + 1}: *`"
                class="required-name"
                ref="name"
                type="text"
                v-model="model.defect_name[index]"
                :name="`production.defect_${index}`"
                v-validate="modelValidations.defect_name"
                :error="getFieldErrorByIndex('production.defect', true, index)"
                placeholder="..."
              ></fg-input>
            </div>
            <div class="col-12 col-sm-8 col-lg-3">
              <fg-input
                type="text"
                :label="`${$t('common_words.abbreviation')}: `"
                v-model="model.defect_abbreviature[index]"
                :name="`common_words.abbreviation_${index}`"
                v-validate="modelValidations.defect_abbreviature"
                :error="
                  getFieldErrorByIndex('common_words.abbreviation', true, index)
                "
                placeholder="..."
              >
              </fg-input>
            </div>
            <div class="col-12 col-sm-4 col-lg-2">
              <div class="form-group has-label">
                <label>{{ $t('common_words.deductible') }}</label>
                <el-switch
                  v-model="model.defect_deductible[index]"
                  style="display: block; margin-top: 0.5rem"
                  active-color="#6BA652"
                  inactive-color="#ff4949"
                >
                </el-switch>
              </div>
            </div>
          </div>
          <!-- Botones de acción por fila -->
          <div
            class="col-1 col-sm-4 col-lg-1 d-flex justify-content-center align-items-center"
          >
            <div class="btn-group" role="group">
              <button
                class="btn btn-danger custom-shadow-btn mr-2"
                @click.prevent="handleDelete(index, model.defect_name[index])"
              >
                <em class="fa fa-minus"></em>
              </button>

              <button
                v-if="index === model.defect_quantity - 1"
                class="btn btn-success custom-shadow-btn"
                @click.prevent="handlePlus()"
              >
                <em class="fa fa-plus"></em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        defect_id: [],
        defect_order: [1],
        defect_name: [''],
        defect_abbreviature: [''],
        defect_deductible: [true],
        defect_quantity: 1,
      },
      modelValidations: {
        defect_order: {
          required: false,
          min_value: 1,
          max_value: 10000,
        },
        defect_name: {
          required: true,
        },
        defect_abbreviature: {
          required: false,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinExport, MixinForm, MixinValidations],
  methods: {
    handlePlus() {
      this.model.defect_quantity++;
      const index = this.model.defect_quantity;
      this.model.defect_id.push(null);
      this.model.defect_order.push(index);
      this.model.defect_name.push('');
      this.model.defect_abbreviature.push('');
      this.model.defect_deductible.push(true);
    },

    handleDelete(index, name) {
      if (name) {
        SweetAlert.delete(name).then((result) => {
          if (result.value) this.handleMinus(index);
        });
      } else {
        this.handleMinus(index);
      }
    },

    handleMinus(index = null) {
      if (this.model.defect_quantity > 1) {
        // Eliminar el registro específico
        this.model.defect_id.splice(index, 1);
        this.model.defect_order.splice(index, 1);
        this.model.defect_name.splice(index, 1);
        this.model.defect_abbreviature.splice(index, 1);
        this.model.defect_deductible.splice(index, 1);

        this.model.defect_quantity--;
      } else {
        // Evita que se elimine la última fila
        this.model.defect_id = [null];
        this.model.defect_order = [1];
        this.model.defect_name = [''];
        this.model.defect_abbreviature = [''];
        this.model.defect_deductible = [true];
        this.model.defect_quantity = 1;
      }
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        for (let i = 0; i < this.model.defect_quantity; i++) {
          if (!isset(this.model.defect_name[i])) {
            return this.validationInputsRequired('name');
          } else {
            this.$emit('on-validated', this.model);

            return res;
          }
        }
      });
    },
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));

      const { subgroups } = editForm;
      this.model = {
        isEdit: true,
        defect_id: [],
        defect_order: [],
        defect_name: [],
        defect_abbreviature: [],
        defect_deductible: [],
        defect_quantity: subgroups.length,
      };

      subgroups.forEach(
        ({ id, order, name, abreviature, discountable, deleted_at }) => {
          if (!deleted_at) {
            this.model.defect_id.push(id);
            this.model.defect_order.push(order);
            this.model.defect_name.push(name);
            this.model.defect_abbreviature.push(abreviature);
            this.model.defect_deductible.push(discountable);
          }
        }
      );
    }
  },
};
</script>
